module.exports = __webpack_public_path__ + "static/media/invalid.be304417.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/resell/invalid.png
// module id = 2090
// module chunks = 6